import { render } from "./CrossFMScreen.vue?vue&type=template&id=320abc0e&scoped=true&ts=true&lang=pug"
import script from "./CrossFMScreen.vue?vue&type=script&lang=ts"
export * from "./CrossFMScreen.vue?vue&type=script&lang=ts"

import "./CrossFMScreen.vue?vue&type=style&index=0&id=320abc0e&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-320abc0e"]])

export default __exports__